import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import QRCode from "react-qr-code";
import agent from "src/agent";
import PersonalizedHotelPackage from "./PersonalizedHotelPackage";
import InteractiveHotelPackageCustomizer from "./InteractiveHotelPackageCustomizer";
const short = require("short-uuid");

interface ChooseRoomProps {
  onOptionChosen: (option: string) => void;
  option?: string;
}

let fullName = '';

const ChooseRoom = (props: ChooseRoomProps) => {
  const [selectedPlan, setSelectedPlan] = useState<string>("");
  const [qrUrl, setQrUrl] = useState<string>("");
  const [infoReceived, setInfoReceived] = useState<boolean>(false);

  const handleSelectPlan = (plan: string) => {
    setSelectedPlan(plan);
  };

  let agentbaseUrl = process.env.REACT_APP_BACKEND_BASE_URI;

  let getToken = async () =>  {
    let maenadaUrlTransaction= "https://maenada-oid4vc-issuer.veridos-egov.com/oauth2/token";

    let formData = new FormData();
    formData.append('grant_type', 'client_credentials');

    let response = await fetch(maenadaUrlTransaction, {
      method: "POST",
      mode: 'cors',
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Authorization": "Basic dmVyaWZpZXItdWktY2xpZW50OnNlY3JldDI="
      },
      body: formData,
    });
    let token = await response.json();
    await getVCRequestUrl(token.access_token);
    //console.log(transactionInfo);
    return token.access_token;
  }

  let getVCRequestUrl = async (token: string) =>  {
        
    // let response = await fetch(agentbaseUrl + "/webapp/definitions/" + credType + "/auth-requests", {
    //     method: "POST",
    //     mode: 'cors',
    //     headers: {
    //       Accept: "*/*",
    //       "Content-Type": "application/json"
    //     }
    //   });
    //   let responseJson = await response.json();
      
    //   let qrUri = responseJson.authRequestURI;


    //   setQrUrl(qrUri);
    let initTransaction = {
      "presentationRequest": {
          "nonce": "67cOfb9c-eb45-44d0-b26c-89afa3634481",
          "id": "pid-or-photo-id-for-check-in"
      },
      "metadata": {
          "requestObjectUsage": "",
          "urlScheme": "openid4vp://"
      }
    };
    let maenadaUrlTransaction= "https://maenada-oid4vc-verifier.veridos-egov.com/openid4vp/transactions";

    let response = await fetch(maenadaUrlTransaction, {
      method: "POST",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      },
      body: JSON.stringify(initTransaction),
    });
    let transactionInfo = await response.json();
          waitForResponse(token, transactionInfo.expandedRepresentation.transaction_id);   
    //console.log(transactionInfo);
    // this.setState({uri: transactionInfo.urlRepresentation, originalUri: transactionInfo.urlRepresentation});
    let qrUri = transactionInfo.urlRepresentation
    setQrUrl(qrUri);
    return qrUri;
 }
let waitForResponse = async(token: string, transactionId:any) => {
    const params = new URLSearchParams(document.location.search);
    const transactionIdParam = params.get('transactionId');
    transactionId = (transactionIdParam != null && transactionIdParam != "") ? transactionIdParam : transactionId;
    let maenadaUrlTransaction= "https://maenada-oid4vc-verifier.veridos-egov.com/openid4vp/transactions/" + transactionId;

    let response = await fetch(maenadaUrlTransaction, {
      method: "GET",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      }
    });
    let transactionInfo = await response.json();
    const transactionClaims = transactionInfo.claims ?? {};
    const preferredClaims =
      transactionClaims['org.iso.23220.2'] ??
      transactionClaims['org.iso.23220.1'];
      switch(transactionInfo.status){
        case "VERIFIED":
          setInfoReceived(true);
          if(preferredClaims) {
            fullName = preferredClaims.given_name + ' ' + preferredClaims.family_name
          } else {
            fullName = transactionClaims.given_name + ' ' + transactionClaims.family_name
          }
          props.onOptionChosen("customized");
          break;
        default:
          setTimeout(() => waitForResponse(token, transactionId), 2000);
          break;
      }
}

let generateNewQRCode = async () => {
    const shortUuid = short.generate();
    await getToken();
  };

  let renderQRCode = () => {
    if (qrUrl != null &&  qrUrl != "")
      return (
        <QRCode className="qr-code-ssi"  value={qrUrl ?? ""} />
      );
    return null;
  }

  useEffect(() => {
    if (props.option === "customized") {
      setInfoReceived(true);
    } else {
      generateNewQRCode();
    }

    
  }, []);

  return (
    <Container fluid className="pricing-area pt-50 pb-90">
      <Container>
        {infoReceived == false ? (
          <Container>
            <Row>
              <Col>
                <div
                  className="section-title text-center"
                  style={{ marginBottom: "50px" }}
                >
                  <h2 className="title">Share your Traveler Profile for an ultra personalized experience</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div
                  className="section-title text-center"
                  style={{ marginBottom: "50px" }}
                >
                  {renderQRCode()}
                </div>
              </Col>
            </Row>
            <Row>
          <Col>
            <div
              className="section-title text-center"
              style={{ marginBottom: "50px" }}
            >
              <h2 className="title">or</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div
              className="section-title text-center"
              style={{ marginBottom: "50px" }}
            >
              <h2 className="title">Choose Room Type</h2>
            </div>
          </Col>
        </Row>
        <div id="prices" className="pricing-plan-wrap">
          <Row>
            <Col>
              <div
                className="pricing-item"
                style={{
                  marginBottom: "30px",
                  border:
                    selectedPlan === "10GB"
                      ? "2px solid red"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleSelectPlan("10GB")}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">Double Room</h3>
                    <h5 className="sub-title">Breakfast included</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>Beautiful room with lake view</li>
                  </ul>
                  <div className="price-wrap">
                    <h3 className="price">
                      125 EUR <sub>per Night</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-lg-4 col-md-6 col-sm-9">
              <div
                className="pricing-item mb-30"
                style={{
                  border:
                    selectedPlan === "20GB"
                      ? "2px solid red"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleSelectPlan("20GB")}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">Junior Suite</h3>
                    <h5 className="sub-title">Breakfast included</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>Junior Suite with lake view</li>
                  </ul>
                  <div className="price-wrap">
                    <h3 className="price">
                      150 EUR <sub>per Night</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-lg-4 col-md-6 col-sm-9">
              <div
                className="pricing-item mb-30"
                style={{
                  border:
                    selectedPlan === "50GB"
                      ? "2px solid red"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleSelectPlan("50GB")}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">Family suite</h3>
                    <h5 className="sub-title">Breakfast included</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                  <li>Family Suite with lake view</li>
                  </ul>
                  <div className="price-wrap">
                    <h3 className="price">
                      200 EUR <sub>per Month</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
          </Container>
        ) : (
          <Container>
            <Row>
              <Col>
                <div
                  className="section-title text-center"
                  style={{ marginBottom: "50px" }}
                >
                  <InteractiveHotelPackageCustomizer fullName={fullName}></InteractiveHotelPackageCustomizer>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                
              </Col>
            </Row>
          </Container>
        )}
      </Container>
    </Container>
  );
};

export default ChooseRoom;
